import { Info } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ScholarshipNotificationBanner = () => {
  return (
    <div className="border border-info bg-info/10 rounded-lg py-2 px-6">
      <div className="flex gap-6 items-start">
        <Info className="stroke-info min-h-6 min-w-6" />
        <p className="text-info">
          To discover scholarship opportunities that can support your journey,
          click{' '}
          <Link
            to="https://forms.alxafrica.com/252602822004545"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold hover:underline"
          >
            here
          </Link>
          .
        </p>
      </div>
    </div>
  );
};
